var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"13","height":"10","viewBox":"0 0 13 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.25 5.75L4.25 8.75L11.75 1.25","stroke":"white","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }